module.exports = __webpack_public_path__ + "img/65.4d9d534a.webp";